module.exports = __webpack_public_path__ + "static/media/paypers.52fc69dc.jpg";